import React, { FC, useEffect, useState } from 'react'
import { payChannelMobx, payPlanMobx } from '@mobxStore'
import { find } from '@dt/fe-utils/dist/lodash'
import { apConfigG } from '@ctrls/third'
import AlipaySimpleItem from './SimpleItem'
import { observer } from 'mobx-react'

interface IProps {
  selected?: boolean;
}

const AlipayMethodItem: FC<IProps> = ({ selected }) => {
  const amount = payPlanMobx.externalMethod?.amount
  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    const method = find(
      payChannelMobx.availableExternalMethods,
      (x) => x === 'AlipayApp'
    )
    if (method) {
      const channel = payChannelMobx.methodChannel[method]
      if (channel.channelType === 'AlipayApp') {
        apConfigG.init(() => {
          setIsShow(true)
        })
      } else {
        setIsShow(true)
      }
    }
    return () => {
      apConfigG.remove()
    }
  }, [payChannelMobx.availableExternalMethods])

  // return (
  //   setIsShow && <AlipaySimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('AlipayApp')} />
  // )
  return (
    <AlipaySimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('AlipayApp')} />
  )
}

export default observer(AlipayMethodItem)
